module.exports = __webpack_public_path__ + "images/e40b8f0786028729a6c4dbf5f8446adc.png";